/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import HomeView from "./homeView";
import WhySofia from "./whySofia";
import ExpertiseView from "./ExpertiseView";

export default function Index() {
  return (
    <>
      <IndexNavbar fixed />
      <HomeView />
      <section id="about" className="mt-48 md:mt-40 pb-40 relative bg-blueGray-100">
        {/* Existing content... */}
      </section>

      {/* New Section: Why Sofia? */}

      <WhySofia />

      {/* New Section: Core Services */}
      <section id="Service" className="py-20 bg-blueGray-100">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center text-center mb-24">
            <div className="w-full lg:w-6/12 px-4">
              <h2 className="text-4xl font-semibold">Core Services</h2>
              <p className="text-lg leading-relaxed mt-4 text-blueGray-500">
                Proofreading, Editing, and More
              </p>
            </div>
          </div>
          <div className="flex flex-wrap">
            <div className="w-full md:w-4/12 px-4 ">
              {/* <div className="text-center p-8"> */}
              <div className="text-left p-8 bg-white rounded-lg">

                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
                  {/* <i className="fas fa-pencil-alt text-xl"></i> */}
                  <img src={require("assets/icon/proofreading.png")}

                    alt="Proofreading & Editing" className="w-16 h-16" />
                </div>
                <h6 className="text-xl font-semibold">Proofreading & Editing</h6>
                <p className="mt-2 text-blueGray-500">
                  We identify and correct errors in grammar, spelling, punctuation, and formatting. We also improve clarity, conciseness, and style to ensure that your message resonates with your audience.
                </p>
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4 ">
              {/* <div className="text-center p-8"> */}
              <div className="text-left p-8 bg-white rounded-lg">

                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
                  {/* <i className="fas fa-chalkboard-teacher text-xl"></i> */}
                  <img src={require("assets/icon/conversation.png")}

                    alt="Proofreading & Editing" className="w-16 h-16" />
                </div>
                <h6 className="text-xl font-semibold">Consulting</h6>
                <p className="mt-2 text-blueGray-500">
                  Need expert advice on your writing project? Our consulting service provides tailored guidance and support.
                </p>
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4  ">
              {/* <div className="text-center p-8"> */}
              <div className="text-left p-8 bg-white rounded-lg">

                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center ">
                  {/* <i className="fas fa-file-alt text-xl"></i> */}
                  <img src={require("assets/icon/cv.png")}

                    alt="Proofreading & Editing" className="w-16 h-16" />
                </div>
                <h6 className="text-xl font-semibold">CV Check</h6>
                <p className="mt-2 text-blueGray-500">
                  A polished CV is your ticket to career success. We review your CV for clarity, impact, and relevance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* New Section: Who Needs Sofia's Expertise? */}
<ExpertiseView />

      {/* New Section: Ready to Perfect Your Writing? */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center text-center mb-8">
            <div className="w-full lg:w-8/12 px-4">
              <h2 className="text-4xl font-semibold text-white">Ready to Perfect Your Writing?</h2>
              <p className="text-lg leading-relaxed mt-4 text-blueGray-300">
                Join thousands of satisfied clients who trust Sofia for their editing needs.
              </p>
              <Link to="/form" className="p-8 mt-8 inline-block bg-white text-black font-bold py-3 px-8 rounded-lg hover:bg-blueGray-200 transition duration-300">
                Go To Form
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Existing Download Section... */}
      <section id="download" className="block relative z-1 bg-blueGray-600">
        {/* Existing content... */}
      </section>

      <Footer />
    </>
  );
}